import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "boolean-feature-flags"
    }}>{`Boolean feature flags`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`if (await Posthog().isFeatureEnabled('flag-key')) {
  // Do something differently for this user

  // Optional: fetch the payload
  final matchedFlagPayload = await Posthog().getFeatureFlagPayload('flag-key');
}
`}</code></pre>
    <h3 {...{
      "id": "multivariate-feature-flags"
    }}>{`Multivariate feature flags`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`if (await Posthog().getFeatureFlag('flag-key') == 'variant-key') { // replace 'variant-key' with the key of your variant
  // Do something differently for this user

  // Optional: fetch the payload
  final matchedFlagPayload = await Posthog().getFeatureFlagPayload('flag-key');
}
`}</code></pre>
    <h3 {...{
      "id": "ensuring-flags-are-loaded-before-usage"
    }}>{`Ensuring flags are loaded before usage`}</h3>
    <p>{`Every time a user opens the app, we send a request in the background to fetch the feature flags that apply to that user. We store those flags in the storage.`}</p>
    <p>{`This means that for most screens, the feature flags are available immediately – `}<strong parentName="p">{`except for the first time a user visits`}</strong>{`.`}</p>
    <h3 {...{
      "id": "reloading-feature-flags"
    }}>{`Reloading feature flags`}</h3>
    <p>{`Feature flag values are cached. If something has changed with your user and you'd like to refetch their flag values, call:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`await Posthog().reloadFeatureFlags();
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      